import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";

// Vitrine Pages
import HomePage from "./pages/vitrine/HomePage";
import MaterialsPage from "./pages/vitrine/MaterialsPage";
import RealizationsPage from "./pages/vitrine/RealizationsPage";
import SavoirFairePage from "./pages/vitrine/SavoirFairePage";
import ContactPage from "./pages/vitrine/ContactPage";

// Auth
import LoginPage from "./pages/auth/LoginPage";

// Pro Dashboard
import DashboardLayout from "./components/layouts/DashboardLayout";
import DashboardHome from "./pages/dashboard/DashboardHome";
import QuotesHistory from "./pages/dashboard/QuotesHistory";
import QuoteDetail from "./pages/dashboard/QuoteDetail";
import ProfilePage from "./pages/dashboard/ProfilePage";
import MessagesPage from "./pages/dashboard/MessagesPage";
import DashboardPlanning from "./pages/dashboard/DashboardPlanning";

// Configurator
import Configurator from "./pages/configurator/Configurator";

// Admin
import AdminLayout from "./components/layouts/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminMaterials from "./pages/admin/AdminMaterials";
import AdminFinishings from "./pages/admin/AdminFinishings";
import AdminEdges from "./pages/admin/AdminEdges";
import AdminServices from "./pages/admin/AdminServices";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminPlanning from "./pages/admin/AdminPlanning";

// Protected Route Component
import ProtectedRoute from "./components/ProtectedRoute";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Vitrine Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/nos-matieres" element={<MaterialsPage />} />
          <Route path="/realisations" element={<RealizationsPage />} />
          <Route path="/savoir-faire" element={<SavoirFairePage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Auth */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Pro Dashboard Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardHome />} />
            <Route path="devis" element={<QuotesHistory />} />
            <Route path="devis/:id" element={<QuoteDetail />} />
            <Route path="planning" element={<DashboardPlanning />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="profil" element={<ProfilePage />} />
          </Route>
          
          {/* Configurator */}
          <Route path="/configurateur" element={
            <ProtectedRoute>
              <Configurator />
            </ProtectedRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="materiaux" element={<AdminMaterials />} />
            <Route path="faconnage" element={<AdminFinishings />} />
            <Route path="chants" element={<AdminEdges />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="planning" element={<AdminPlanning />} />
            <Route path="utilisateurs" element={<AdminUsers />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="devis" element={<QuotesHistory />} />
            <Route path="devis/:id" element={<QuoteDetail />} />
          </Route>
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
